(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-service"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".cs-tab-btn");
  const contents = document.querySelectorAll(".cs-tab-content");

  tabs.forEach((tab, i) => {
    tab.addEventListener("click", () => {
      if (!tab.classList.contains("active")) {
        tabs.forEach(t => t.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));

        tab.classList.add("active");
        contents[i].classList.add("active");
      }
    });
  });

  // FAQ accordion toggle
  document.querySelectorAll(".faq-question").forEach(q => {
    q.addEventListener("click", function() {
      const ans = this.nextElementSibling;
      if (ans.style.display === "block") {
        ans.style.display = "none";
      } else {
        ans.style.display = "block";
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["engagement-ring"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  /* =========================
     SCROLL ANIMATION
  ========================= */
  const elements = document.querySelectorAll(".scroll-animate");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
      }
    });
  }, { threshold: 0.3 });

  elements.forEach(el => observer.observe(el));


  /* =========================
     REELS SLIDER (FINAL STABLE)
  ========================= */

  const wrapper = document.getElementById("reelsWrapper");
  let items = Array.from(document.querySelectorAll(".reel-item"));

  if (!wrapper || items.length < 2) return;

  let index = 1;
  let hasStarted = false;
  let isTransitioning = false;

  // CLONES (infinite loop)
  const firstClone = items[0].cloneNode(true);
  const lastClone = items[items.length - 1].cloneNode(true);

  wrapper.appendChild(firstClone);
  wrapper.insertBefore(lastClone, items[0]);

  items = Array.from(document.querySelectorAll(".reel-item"));

  /* PLAY VIDEO FUNCTION (SAFE) */
  function playActiveVideo() {
    items.forEach(item => {
      const v = item.querySelector("video");
      if (v) {
        v.pause();
        v.currentTime = 0;
        v.onended = null; // 🔥 reset old events
      }
    });

    const activeVideo = items[index].querySelector("video");

    if (activeVideo) {
      activeVideo.muted = true;
      activeVideo.play().catch(() => {});

      // 🔥 instant next on end
      activeVideo.onended = () => {
        if (!isTransitioning) {
          nextSlide();
        }
      };
    }
  }

  function updateSlider(animate = true) {
    const itemWidth = items[0].offsetWidth + 20;

    wrapper.style.transition = animate ? "transform 0.5s ease" : "none";
    wrapper.style.transform = `translateX(-${index * itemWidth}px)`;

    items.forEach(item => item.classList.remove("active"));
    items[index].classList.add("active");

    playActiveVideo();
  }

  function nextSlide() {
    if (isTransitioning) return;
    isTransitioning = true;

    index++;
    updateSlider();

    if (index === items.length - 1) {
      setTimeout(() => {
        index = 1;
        updateSlider(false);
        isTransitioning = false;
      }, 500);
    } else {
      setTimeout(() => {
        isTransitioning = false;
      }, 500);
    }
  }

  function prevSlide() {
    if (isTransitioning) return;
    isTransitioning = true;

    index--;
    updateSlider();

    if (index === 0) {
      setTimeout(() => {
        index = items.length - 2;
        updateSlider(false);
        isTransitioning = false;
      }, 500);
    } else {
      setTimeout(() => {
        isTransitioning = false;
      }, 500);
    }
  }

  /* =========================
     AUTO START ON SCROLL
  ========================= */
  const reelObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasStarted) {
        hasStarted = true;
        updateSlider(false);
      }
    });
  }, { threshold: 0.5 });

  const reelSection = document.querySelector(".engagement-right");
  if (reelSection) {
    reelObserver.observe(reelSection);
  }

  const nextBtn = document.getElementById("nextReel");
  const prevBtn = document.getElementById("prevReel");

  if (nextBtn && prevBtn) {
    nextBtn.addEventListener("click", () => {
      nextSlide();
    });

    prevBtn.addEventListener("click", () => {
      prevSlide();
    });
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
